import React from 'react';
import { DividerProps, DividerOrientation, DividerVariant } from '../../../types/DesignSystem/Divider';

const orientationStyles: Record<DividerOrientation, string> = {
  horizontal: 'tw-w-full tw-h-px',
  vertical: 'tw-h-full tw-w-px',
};

const variantStyles: Record<DividerVariant, string> = {
  solid: 'tw-border-grey-200',
  dashed: 'tw-border-dashed tw-border-grey-200',
};

const Divider: React.FC<DividerProps> = ({
  orientation = 'horizontal',
  variant = 'solid',
  className = '',
}) => {
  return (
    <div
      className={`tw-border-0 tw-border-t ${orientationStyles[orientation]} ${variantStyles[variant]} ${className}`}
      role="separator"
      aria-orientation={orientation}
    />
  );
};

export default Divider;
